import { render, staticRenderFns } from "./CoreValuesFiveIcon.vue?vue&type=template&id=76d3ee14&"
import script from "./CoreValuesFiveIcon.vue?vue&type=script&lang=js&"
export * from "./CoreValuesFiveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports